import { OPEN_IN_BROWSER_QUERY_PARAM, OPEN_IN_BROWSER_QUERY_VALUE } from './sem-redirect-query.constants';

export const shouldSkipSemRedirect: (url: string) => boolean = (url: string): boolean => {
  if (!url?.includes('?')) {
    return false;
  }

  const queryString: string = url.split('?')[1]?.split('#')[0] ?? '';

  return new URLSearchParams(queryString).get(OPEN_IN_BROWSER_QUERY_PARAM) === OPEN_IN_BROWSER_QUERY_VALUE;
};
